import { useCallback, useRef } from 'react';

export function RangeSlider({ min, max, step, value, onChange }: {
  min: number; max: number; step: number;
  value: [number, number]; onChange: (v: [number, number]) => void;
}) {
  const trackRef = useRef<HTMLDivElement>(null);

  const pct = (v: number) => ((v - min) / (max - min)) * 100;

  const valFromX = useCallback((clientX: number) => {
    const rect = trackRef.current!.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    const raw = min + ratio * (max - min);
    return Math.round(raw / step) * step;
  }, [min, max, step]);

  const startDrag = useCallback((thumbIndex: 0 | 1) => (e: React.PointerEvent) => {
    e.preventDefault();
    const target = e.currentTarget as HTMLElement;
    target.setPointerCapture(e.pointerId);

    const onMove = (ev: PointerEvent) => {
      const v = valFromX(ev.clientX);
      onChange(thumbIndex === 0
        ? [Math.min(v, value[1]), value[1]]
        : [value[0], Math.max(v, value[0])]);
    };
    const onUp = () => {
      target.removeEventListener('pointermove', onMove);
      target.removeEventListener('pointerup', onUp);
    };
    target.addEventListener('pointermove', onMove);
    target.addEventListener('pointerup', onUp);
  }, [valFromX, onChange, value]);

  return (
    <div className="prop-slider-root" ref={trackRef}>
      <div className="prop-slider-track">
        <div className="prop-slider-range" style={{ left: `${pct(value[0])}%`, width: `${pct(value[1]) - pct(value[0])}%` }} />
      </div>
      <div className="prop-slider-thumb" style={{ left: `${pct(value[0])}%` }} onPointerDown={startDrag(0)} />
      <div className="prop-slider-thumb" style={{ left: `${pct(value[1])}%` }} onPointerDown={startDrag(1)} />
    </div>
  );
}
